enum ElementAlignment {
  ALIGN_LEFT = "align-left",
  ALIGN_CENTER = "align-center",
  ALIGN_RIGHT = "align-right",
  ALIGN_JUSTIFY = "align-justify",
}

export default ElementAlignment;
